import {
  axios
} from '@/utils/request'
import user from '@/config/debug.config'

const api = {
  Login: '/5c9caf3111ea8',
  Smslogin: '/5c9d90628affb',
  Logout: '/auth/logout',
  ForgePassword: '/auth/forge-password',
  Register: '/5c9d825b7e691',
  twoStepCode: '/auth/2step-code',
  SendSms: '/5c9d86eeecc05',
  SendRegSms: '/5c9d843d817a2',
  resetPassword: '/5c9d8da433492',
  // get my info
  UserInfo: '/5c9d81486c58f',
  // 新增欢喜物流注册的短信
  hxwlLogin: '/63903f1dcac4b',
}

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login({
  username,
  password,
  token
}) {
  const parameter = {
    username,
    password,
    captchaToken: token
  }
  return axios({
    url: api.Login,
    method: 'post',
    data: parameter
  })
}

export function smslogin({
  mobile,
  captcha
}) {
  const parameter = {
    mobile,
    captcha
  }
  return axios({
    url: api.Smslogin,
    method: 'post',
    data: parameter
  })
}

export function register({
  captcha,
  mobile,
  password,
  confirmPassword,
  invite_code
}) {
  const parameter = {
    captcha,
    mobile,
    password,
    confirm_password: confirmPassword,
    invite_code: invite_code
  }
  return axios({
    url: api.Register,
    method: 'post',
    data: parameter
  })
}
// 重置密码
export function resetPassword({
  captcha,
  mobile,
  password,
  confirmPassword
}) {
  const parameter = {
    captcha,
    mobile,
    password,
    confirm_password: confirmPassword
  }
  return axios({
    url: api.resetPassword,
    method: 'post',
    data: parameter
  })
}
// 登录短信
export function getSmsCaptcha({
  mobile,
  token
}) {
  const parameter = {
    phoneNumber: mobile,
    captchaToken: token
  }
  return axios({
    url: api.SendSms,
    method: 'get',
    params: parameter
  })
}
// 注册短信
export function getRegSmsCaptcha({
  mobile,
  token
}) {
  const parameter = {
    phoneNumber: mobile,
    captchaToken: token
  }
  return axios({
    url: api.SendRegSms,
    method: 'get',
    params: parameter
  })
}

// 欢喜物流注册短信
export function hxwlLogin({
  mobile,
  token
}) {
  const parameter = {
    phoneNumber: mobile,
    captchaToken: token
  }
  return axios({
    url: api.hxwlLogin,
    method: 'get',
    params: parameter
  })
}


export function getInfo() {
  return axios({
    url: api.UserInfo,
    method: 'get'
  }).then((res) => {
    // console.log(res.data)
    if ((res.code === 1) && res.data) {
      res.data.avatar = 'https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png'
      res.data.id = res.data.user.id
      res.data.role = {
        id: 'robot',
        name: '机器人',
        permissions: [{
          permissionId: user.includes(res.data.user.username) ? 'debug' : 'user'
        }]
      }
    }
    return res
  })
}

export function logout() {
  return axios({
    url: '/auth/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step(parameter) {
  return axios({
    url: api.twoStepCode,
    method: 'post',
    data: parameter
  })
}